import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchUserSubscriptionStatusFromApi } from 'utils/primeUtil';
import { loginWithGoogleCredentialsEventEmitter } from 'components/Login';
import jsonp from 'jsonp';
import {
  PRC_PRIME_API_MOB,
  PRC_PRIME_API_DESKTOP,
  TOI_SUBS_FETCH_PLAN_STATUS_MWEB,
  TOI_SUBS_FETCH_PLAN_STATUS_WEB,
} from 'constants/index';
import makeRequest from 'utils/makeRequest';
import { toggleLoginBox } from 'components/Login/redux';
import _get from 'lodash.get';
import Cookie from '../../../utils/cookies';
import { isPrimeUser, getSsoidAndTicket } from '../../../utils/common';

// Google extended acces flow component applicable for google newshowcase only for free reads
function GoogleEAFlowNew({
  toggleloginBox,
  userData,
  storymsid,
  isWapView,
  openLogin,
  userPrcData,
}) {
  // eslint-disable-next-line camelcase
  const GE_Access_msids = 'GE_Access_msids';
  const [msid] = useState(storymsid);
  const prevUserData = useRef(null);
  let domainUrl;
  let channelJsso;
  let alreadyPostedLogin = false;
  if (isWapView) {
    domainUrl = 'https://m.timesofindia.com';
    channelJsso = 'WAP';
  } else {
    domainUrl = 'https://timesofindia.indiatimes.com';
    channelJsso = 'web';
  }

  function getUrlParams() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length !== 0 && params.constructor === Object) {
      return params;
    }
    return null;
  }

  function logoutAction() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = getUrlParams();
    if (
      Object.keys(params).length !== 0 &&
      params.constructor === Object &&
      params.entitlementcheck
    ) {
      urlSearchParams.delete('entitlementcheck');
      window.location.href = `${
        window.location.pathname
      }?${urlSearchParams.toString()}`;
    } else {
      window.location.reload();
    }
  }

  function showGoogleRegwall() {
    let rgTimeSso;
    document.getElementsByTagName('body')[0].classList.add('noScroll');
    function getAllowedMsids() {
      return new Promise(resolve => {
        const url =
          'https://subs.timesofindia.com/subscriptions/proxy/gsc/fetch-showcase/json';

        if (!sessionStorage.getItem(GE_Access_msids)) {
          makeRequest
            .get(url, {}, 'skipfeedengine')
            .then(resp => {
              if (resp && resp.data && resp.data.data) {
                const allowedMsids =
                  resp.data.data.length > 0
                    ? resp.data.data.map(obj => parseInt(obj.msid, 10))
                    : [];
                sessionStorage.setItem(
                  GE_Access_msids,
                  JSON.stringify({
                    data: allowedMsids,
                    stored_at: new Date(),
                  }),
                );
                resolve(allowedMsids);
              } else {
                resolve([]);
              }
            })
            .catch(() => {
              resolve([]);
            });
        } else {
          const msidsData = JSON.parse(sessionStorage.getItem(GE_Access_msids));
          const now = new Date();
          const expiration = new Date(msidsData.stored_at);
          expiration.setMinutes(expiration.getMinutes() + 10);

          if (now.getTime() > expiration.getTime()) {
            sessionStorage.removeItem(GE_Access_msids);
            getAllowedMsids()
              .then(allowedMsids => {
                resolve(allowedMsids);
              })
              .catch(() => {
                resolve([]);
              });
          } else {
            resolve(msidsData.data);
          }
        }
      });
    }

    function getUserState(ssoid) {
      const ssoid1 = ssoid || Cookie.get('ssoid') || Cookie.get('ssoId');
      const timestamp =
        rgTimeSso || Cookie.get('rgtime')
          ? parseInt(Cookie.get('rgtime'), 10)
          : parseInt(new Date().getTime() / 1000, 10);

      const key = `toi_userstate_${ssoid1}`;
      const userStateDetails =
        localStorage &&
        localStorage.getItem(key) !== '' &&
        JSON.parse(localStorage.getItem(key));
      let userState = null;
      if (
        userStateDetails &&
        userStateDetails?.userState &&
        userStateDetails?.stored_at + 30 * 24 * 60 * 60 > timestamp
      ) {
        userState = userStateDetails.userState;
      }
      if (!userState) {
        userState = (ssoid1 && {
          id: ssoid1,
          registrationTimestamp: timestamp - 10,
        }) || { granted: false };
        if (userState) {
          localStorage.setItem(
            key,
            JSON.stringify({
              userState,
              stored_at: timestamp,
            }),
          );
        }
      }
      return userState;
    }

    function setNativePrc() {
      const url = isWapView ? PRC_PRIME_API_MOB : PRC_PRIME_API_DESKTOP;
      return makeRequest.get(url, {
        withCredentials: true,
      });
    }
    const getPrcDataAPI = () => {
      const { ticketId, ssoId } = getSsoidAndTicket();
      if (ssoId && ticketId) {
        const url = isWapView
          ? TOI_SUBS_FETCH_PLAN_STATUS_MWEB
          : TOI_SUBS_FETCH_PLAN_STATUS_WEB;
        return makeRequest.get(url, {
          headers: {
            ticketId,
            ssoId,
          },
          params: {
            rspBody: true,
          },
        });
      }
      return null;
    };

    function checkPrimeArticle(resolve_) {
      const { ticketId, ssoId } = getSsoidAndTicket();
      if (ssoId && ticketId) {
        getPrcDataAPI().then(res => {
          if (
            res &&
            res.status === 200 &&
            res.data &&
            typeof res.data === 'object'
          ) {
            const prcData = res.data;
            fetchUserSubscriptionStatusFromApi(prcData).then(() => {
              const userStateObj = getUserState() || {};

              let publisherEntitlement = { ...userStateObj, granted: false };
              const paidstoriesArr =
                sessionStorage.getItem('paidstories') &&
                sessionStorage.getItem('paidstories') != null
                  ? sessionStorage.getItem('paidstories').split(',')
                  : [];

              setNativePrc().then(() => {
                if (isPrimeUser()) {
                  document
                    .getElementsByTagName('body')[0]
                    .classList.remove('noScroll');
                  publisherEntitlement = {
                    ...userStateObj,
                    granted: true,
                    grantReason: 'SUBSCRIBER',
                  };
                  resolve_(publisherEntitlement);
                } else if (
                  typeof msid !== 'undefined' &&
                  typeof paidstoriesArr !== 'undefined' &&
                  paidstoriesArr.length > 0
                ) {
                  if (paidstoriesArr.includes(msid.toString())) {
                    document
                      .getElementsByTagName('body')[0]
                      .classList.remove('noScroll');
                    publisherEntitlement = {
                      ...userStateObj,
                      granted: true,
                      grantReason: 'METERING',
                    };
                    resolve_(publisherEntitlement);
                  }
                } else {
                  getAllowedMsids().then(allowedMsids => {
                    if (allowedMsids.includes(parseInt(msid, 10))) {
                      resolve_(publisherEntitlement);
                    } else {
                      const urlSearchParams = new URLSearchParams(
                        window.location.search,
                      );
                      const params = Object.fromEntries(
                        urlSearchParams.entries(),
                      );
                      if (
                        Object.keys(params).length !== 0 &&
                        params.constructor === Object &&
                        !params.entitlementcheck
                      ) {
                        window.location.search +=
                          '&entitlementcheck=noentitlements';
                      } else {
                        document
                          .getElementsByTagName('body')[0]
                          .classList.remove('noScroll');
                      }
                    }
                  });
                }
              });
            });
          }
        });
      }
    }

    function showLoginPopup(visible = true) {
      if (document.getElementById('login-popup')) {
        if (visible) {
          document
            .getElementById('login-popup')
            .style.removeProperty('visibility');
        } else {
          document.getElementById('login-popup').style.visibility = 'hidden';
        }
      }
    }

    //entitlements with publisher promise
    const publisherEntitlementPromiseLocal = new Promise(resolve => {
      if (Cookie.get('ssoid') || Cookie.get('ssoId')) {
        checkPrimeArticle(resolve);
      } else {
        resolve({ granted: false });
      }
    }).then(console.log('Subscriptions publisherEntitlementPromise'));

    const registerUserPromiseLocal = new Promise(resolve => {
      window.GaaMetering.getGaaUserPromise().then(credentialResponse => {
        const channel = 'toi';
        if (credentialResponse && credentialResponse.credential) {
          window.alreadyLoggedinFlag = true;
          const jssoAPIGetURL =
            'https://jsso.indiatimes.com/sso/services/gponetaplogin/verify';
          const ru = 'bchjqhklhblchbhjglh1wbfbv';
          const onSuccessCallback = (err, resp) => {
            let ticketId;
            ticketId = resp?.data?.ticket;
            const ssoId = resp?.data?.ssoid;
            if (ssoId && ticketId) {
              const jssoCrosswalkObj = new window.JssoCrosswalk(
                'toi',
                channelJsso,
              );
              jssoCrosswalkObj.gpOneTapLogin(
                credentialResponse.credential,
                ssoResponse => {
                  ticketId = ssoResponse?.data?.ticket;
                  jssoCrosswalkObj.getValidLoggedInUser(response => {
                    if (response.code === 200) {
                      showLoginPopup(false);
                      loginWithGoogleCredentialsEventEmitter();
                      //To be removed: This patch is used to explicitly show the hidden signin form
                      //until process of dialog box complete or in case of failure

                      try {
                        jssoCrosswalkObj.getUserDetails(innerResponse => {
                          //setting rgTime & pass to userState if cookie is not set
                          if (
                            innerResponse &&
                            parseInt(innerResponse.code, 10) === 200 &&
                            typeof callback === 'function' &&
                            innerResponse.data &&
                            innerResponse.data.createdDate !== ''
                          ) {
                            rgTimeSso =
                              new Date(
                                innerResponse.data.createdDate,
                              ).getTime() / 1000;
                          }
                          const options = {};
                          options.ssoId =
                            ssoId ||
                            Cookie.get('ssoid') ||
                            Cookie.get('ssoId') ||
                            '';
                          options.ticketId =
                            ticketId ||
                            Cookie.get('TicketId') ||
                            Cookie.get('ticket') ||
                            '';
                          const { data } = response;
                          const socialappcdurl = `//${
                            window.location.hostname
                          }/v1validateTicket?ticketId=${
                            data.encTicket
                          }&channel=toi-wap&_=${new Date().getTime()}`;
                          jsonp(socialappcdurl, null, () => {
                            setTimeout(() => {
                              if (Cookie.get('ssoid') || Cookie.get('ssoId')) {
                                checkPrimeArticle(resolve);
                              }
                            }, 1000);
                          });
                        });
                      } catch (innerErr) {
                        //console.log('err', innerErr);
                        // showLoginPopup(true);
                      }
                    }
                  });
                },
              );
            }
          };
          jsonp(
            `${jssoAPIGetURL}?token=${
              credentialResponse.credential
            }&channel=${channel}&ru=${ru}`,
            null,
            onSuccessCallback,
          );
        }

        // Register user on your side

        // resolve with the userState object of this new user
      });
    }).then(console.log('Subscriptions registerUserPromise', getUserState()));

    const handleLoginPromiseLocal = new Promise(resolve => {
      window.GaaMetering.getLoginPromise().then(() => {
        toggleloginBox(true);
        document.getElementById('login-popup').classList.add('loginPopupGa');
        document.getElementById('swg-regwall-container').style.zIndex = 'unset';
        window.addEventListener(
          'message',
          message => {
            if (message.data === 'EAloginWindow') {
              // resolve(getUserState());
              checkPrimeArticle(resolve);
            }
          },
          false,
        );
      });
    }).then(console.log('Subscriptions handleLoginPromise'));

    function handleSwGEntitlementLocal() {
      console.log('handleSwGEntitlement');
    }
    function showPaywallLocal() {
      // Is unlocked dialog box visible
      (window.SWG = window.SWG || []).push(subscriptions => {
        subscriptions.getEntitlements(
          window.GaaMetering.newUserStateToUserState({
            id: getUserState().id,
            registrationTimestamp: getUserState().registrationTimestamp,
          }),
        );

        subscriptions.setOnEntitlementsResponse(entitlementsPromise => {
          entitlementsPromise.then(googleEntitlement => {
            if (googleEntitlement.enablesThisWithGoogleMetering()) {
              window.location.href = `${domainUrl}/toi-plus/plans`;
            } else {
              const urlSearchParams = new URLSearchParams(
                window.location.search,
              );
              const params = Object.fromEntries(urlSearchParams.entries());
              if (
                Object.keys(params).length !== 0 &&
                params.constructor === Object &&
                !params.entitlementcheck
              ) {
                window.location.search += '&entitlementcheck=noentitlements';
              } else {
                document
                  .getElementsByTagName('body')[0]
                  .classList.remove('noScroll');
              }
            }
          });
        });
      });
    }
    function unlockArticleLocal() {
      document.getElementsByTagName('body')[0].classList.remove('noScroll');
    }
    window.GaaMetering.init({
      googleApiClientId:
        '103703403489-b4t4lt8mr05brqpcdrmsu0di54cmjv4f.apps.googleusercontent.com',
      userState: getUserState(),
      allowedReferrers: [
        'spmdev.indiatimes.com',
        'https://www.google.com/',
        'timesofindia.indiatimes.com',
        'm.timesofindia.com',
        'vsp1toispastaging.indiatimes.com',
        'toispastg7.indiatimes.com',
      ],
      handleLoginPromise: handleLoginPromiseLocal,
      registerUserPromise: registerUserPromiseLocal,
      publisherEntitlementPromise: publisherEntitlementPromiseLocal,
      unlockArticle: unlockArticleLocal,
      showPaywall: showPaywallLocal,
      handleSwGEntitlement: handleSwGEntitlementLocal,
    });
  }

  function loadGAScriptAndSwgInitialize() {
    const gsiClientSrc = 'https://accounts.google.com/gsi/client';
    const swgSrc = 'https://news.google.com/swg/js/v1/swg.js';
    const swgGaaSrc = 'https://news.google.com/swg/js/v1/swg-gaa.js';
    const gsiClientScript = document.createElement('script');
    const swgScript = document.createElement('script');
    const swgGaaScript = document.createElement('script');

    gsiClientScript.src = gsiClientSrc;
    gsiClientScript.async = true;

    swgScript.src = swgSrc;
    swgScript.async = true;

    swgGaaScript.src = swgGaaSrc;
    swgGaaScript.async = true;

    swgScript.setAttribute('subscriptions-control', 'manual');

    // eslint-disable-next-line func-names
    gsiClientScript.onload = function() {
      document.body.appendChild(swgScript);
    };

    // eslint-disable-next-line func-names
    swgScript.onload = function() {
      document.body.appendChild(swgGaaScript);
    };
    // eslint-disable-next-line func-names
    swgGaaScript.onload = function() {
      window.gaaScriptLoaded = true;
      showGoogleRegwall();
    };
    document.body.appendChild(gsiClientScript);
    window.gaInitFlag = true;
  }
  useEffect(
    () => {
      if (!window.gaInitFlag) {
        loadGAScriptAndSwgInitialize();
      } else if (!openLogin && window.gaInitFlag && window.gaaScriptLoaded) {
        (window.SWG = window.SWG || []).push(subscriptions => {
          subscriptions.setOnLoginRequest(() => {
            toggleloginBox(true);
          });
        });
      }
    },
    [openLogin],
  );

  useEffect(
    () => {
      if (Object.keys(userData).length) {
        if (userData?.isLoggedIn) {
          if (document.getElementById('swg-regwall-container')) {
            window.GaaMeteringRegwall.remove();
          }
          // document.getElementsByTagName('body')[0].classList.remove('noScroll');
          if (!alreadyPostedLogin && userPrcData) {
            alreadyPostedLogin = true;
            window.parent.postMessage('EAloginWindow', '*');
          }
        } else if (
          prevUserData.current &&
          prevUserData.current.isLoggedIn !== userData?.isLoggedIn &&
          userData?.isLoggedIn === false &&
          window.gaInitFlag &&
          window.gaaScriptLoaded
        ) {
          logoutAction();
        }
        prevUserData.current = userData;
      }
    },
    [userData, userPrcData],
  );

  return <></>;
}
const mapStateToProps = state => ({
  userData: _get(state, 'login.userData'),
  openLogin: _get(state, 'login.openLogin'),
  userPrcData: state.login.userPrcData,
  //userPrcData: _get(state, 'login.userPrcData'),
});

const mapDispatchToProps = dispatch => ({
  toggleloginBox: params => {
    dispatch(toggleLoginBox(params));
  },
});

GoogleEAFlowNew.propTypes = {
  storymsid: PropTypes.string,
  userData: PropTypes.arrayOf(PropTypes.shape({})),
  toggleloginBox: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isWapView: PropTypes.bool.isRequired,
};

GoogleEAFlowNew.defaultProps = {
  storymsid: '',
  userData: {},
};
export default connect(mapStateToProps, mapDispatchToProps)(GoogleEAFlowNew);
